import { useState } from "react";
import { Plus, CircleNotch } from "@phosphor-icons/react";

/** "Seller forgot a box" — type a set number, we price it with the Sitewide Rules and add it to the invoice. */
export const AddSetForm = ({ onAdd }) => {
  const [sn, setSn] = useState("");
  const [qty, setQty] = useState("1");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!sn.trim() || busy) return;
    setBusy(true);
    try { if (await onAdd(sn.trim(), Math.max(1, parseInt(qty, 10) || 1))) { setSn(""); setQty("1"); } }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="no-print flex items-center gap-2 flex-wrap border border-dashed border-[#E4E4E0] rounded-sm p-3 bg-[#F6F6F3]" data-testid="add-set-form">
      <span className="text-[10px] font-black tracking-widest text-gray-500">ADD A SET THE SELLER FORGOT</span>
      <input value={sn} onChange={(e) => setSn(e.target.value)} placeholder="set number, e.g. 75192" inputMode="numeric"
        className="h-8 px-2 w-44 rounded-sm border border-[#E4E4E0] bg-white font-mono text-xs outline-none focus:border-black" data-testid="add-set-number" />
      <label className="inline-flex items-center gap-1 font-mono text-xs text-gray-500">×
        <input value={qty} onChange={(e) => setQty(e.target.value.replace(/\D/g, ""))} inputMode="numeric"
          className="h-8 w-12 px-2 rounded-sm border border-[#E4E4E0] bg-white font-mono text-xs text-center outline-none focus:border-black" data-testid="add-set-qty" />
      </label>
      <button type="submit" disabled={busy || !sn.trim()} className="h-8 px-3 inline-flex items-center gap-1 rounded-sm bg-black text-white font-mono text-xs disabled:opacity-40" data-testid="add-set-submit">
        {busy ? <CircleNotch size={12} className="animate-spin" /> : <Plus size={12} weight="bold" />} {busy ? "Pricing…" : "Price & add"}
      </button>
      <span className="font-mono text-[10px] text-gray-500">Priced with the Sitewide Rules{" "}· lands under review if it can't be priced automatically</span>
    </form>
  );
};
